module.exports = __webpack_public_path__ + "img/list_Character_sq_16.ce596a96.jpeg";